import React, { Fragment, useState, useRef } from 'react';
import Slider from 'react-slick';

import { STYLES, PRODUCTS } from './constants';
import './BodyMove.scss';

export const BodyMove = ({ baseImgUrl }) => {
  const [stateMV2001N_5S, setStateMV2001N_5S] = useState({
    currentIndexProduct: 0,
    currentKey: 'C1',
    colors: PRODUCTS['MV2001N-5S'].colors,
  });
  const [stateMV2002N_5S, setStateMV2002N_5S] = useState({
    currentIndexProduct: 0,
    currentKey: 'C1',
    colors: PRODUCTS['MV2002N-5S'].colors,
  });
  const [stateMV2003N_5S, setStateMV2003N_5S] = useState({
    currentIndexProduct: 0,
    currentKey: 'C1',
    colors: PRODUCTS['MV2003N-5S'].colors,
  });
  const [stateMV2004N_5S, setStateMV2004N_5S] = useState({
    currentIndexProduct: 0,
    currentKey: 'C1',
    colors: PRODUCTS['MV2004N-5S'].colors,
  });
  const [stateMV2005N_5S, setStateMV2005N_5S] = useState({
    currentIndexProduct: 0,
    currentKey: 'C1',
    colors: PRODUCTS['MV2005N-5S'].colors,
  });
  const [stateMV2006N_5S, setStateMV2006N_5S] = useState({
    currentIndexProduct: 0,
    currentKey: 'C1',
    colors: PRODUCTS['MV2006N-5S'].colors,
  });

  const MV2001N_5SRef = useRef(null);
  const MV2002N_5SRef = useRef(null);
  const MV2003N_5SRef = useRef(null);
  const MV2004N_5SRef = useRef(null);
  const MV2005N_5SRef = useRef(null);
  const MV2006N_5SRef = useRef(null);

  const productSetting = {
    infinite: true,
    dots: false,
    variableWidth: true,
    centerMode: true,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          infinite: true,
          arrows: false,
        },
      },
      {
        breakpoint: 9999,
        settings: {
          infinite: false,
          arrows: true,
        },
      },
    ],
  };

  const MV2001N_5SSetting = {
    ...productSetting,
    afterChange: async current => {
      await Promise.all([
        MV2001N_5SRef.current.slickGoTo(current, true),
        setStateMV2001N_5S(prev => ({ ...prev, currentIndexProduct: current })),
      ]);
    },
  };
  const MV2002N_5SSetting = {
    ...productSetting,
    afterChange: async current => {
      await Promise.all([
        MV2002N_5SRef.current.slickGoTo(current, true),
        setStateMV2002N_5S(prev => ({ ...prev, currentIndexProduct: current })),
      ]);
    },
  };
  const MV2003N_5SSetting = {
    ...productSetting,
    afterChange: async current => {
      await Promise.all([
        MV2003N_5SRef.current.slickGoTo(current, true),
        setStateMV2003N_5S(prev => ({ ...prev, currentIndexProduct: current })),
      ]);
    },
  };
  const MV2004N_5SSetting = {
    ...productSetting,
    afterChange: async current => {
      await Promise.all([
        MV2004N_5SRef.current.slickGoTo(current, true),
        setStateMV2004N_5S(prev => ({ ...prev, currentIndexProduct: current })),
      ]);
    },
  };
  const MV2005N_5SSetting = {
    ...productSetting,
    afterChange: async current => {
      await Promise.all([
        MV2005N_5SRef.current.slickGoTo(current, true),
        setStateMV2005N_5S(prev => ({ ...prev, currentIndexProduct: current })),
      ]);
    },
  };
  const MV2006N_5SSetting = {
    ...productSetting,
    afterChange: async current => {
      await Promise.all([
        MV2006N_5SRef.current.slickGoTo(current, true),
        setStateMV2006N_5S(prev => ({ ...prev, currentIndexProduct: current })),
      ]);
    },
  };

  const productMap = {
    'MV2001N-5S': {
      setting: MV2001N_5SSetting,
      ref: MV2001N_5SRef,
      limit: PRODUCTS['MV2001N-5S'].limit,
      currentKey: stateMV2001N_5S.currentKey,
      stateProduct: stateMV2001N_5S,
      setState: setStateMV2001N_5S,
    },
    'MV2002N-5S': {
      setting: MV2002N_5SSetting,
      ref: MV2002N_5SRef,
      limit: PRODUCTS['MV2002N-5S'].limit,
      currentKey: stateMV2002N_5S.currentKey,
      stateProduct: stateMV2002N_5S,
      setState: setStateMV2002N_5S,
    },
    'MV2003N-5S': {
      setting: MV2003N_5SSetting,
      ref: MV2003N_5SRef,
      limit: PRODUCTS['MV2003N-5S'].limit,
      currentKey: stateMV2003N_5S.currentKey,
      stateProduct: stateMV2003N_5S,
      setState: setStateMV2003N_5S,
    },
    'MV2004N-5S': {
      setting: MV2004N_5SSetting,
      ref: MV2004N_5SRef,
      limit: PRODUCTS['MV2004N-5S'].limit,
      currentKey: stateMV2004N_5S.currentKey,
      stateProduct: stateMV2004N_5S,
      setState: setStateMV2004N_5S,
    },
    'MV2005N-5S': {
      setting: MV2005N_5SSetting,
      ref: MV2005N_5SRef,
      limit: PRODUCTS['MV2005N-5S'].limit,
      currentKey: stateMV2005N_5S.currentKey,
      stateProduct: stateMV2005N_5S,
      setState: setStateMV2005N_5S,
    },
    'MV2006N-5S': {
      setting: MV2006N_5SSetting,
      ref: MV2006N_5SRef,
      limit: PRODUCTS['MV2006N-5S'].limit,
      currentKey: stateMV2006N_5S.currentKey,
      stateProduct: stateMV2006N_5S,
      setState: setStateMV2006N_5S,
    },
  };

  const isSelectedColor = (currentKey, index) => {
    const selectedColorMap = {
      0: ['C1'],
      1: ['C2'],
      2: ['C3'],
      3: ['C4'],
    };
    return selectedColorMap[index]?.includes(currentKey) || false;
  };

  const handleSelectedColor = (productNumber, index) => {
    if (productMap[productNumber]) {
      const { setState } = productMap[productNumber];
      const productKeys = [
        'MV2001N-5S',
        'MV2002N-5S',
        'MV2003N-5S',
        'MV2004N-5S',
        'MV2005N-5S',
        'MV2006N-5S',
      ];

      const productColorKeyMap = productKeys.reduce((map, key) => {
        map[key] = ['C1', 'C2', 'C3', 'C4'];
        return map;
      }, {});

      const colorKeys = productColorKeyMap[productNumber];
      const newCurrentKey = colorKeys?.[index] || null;

      setState(prev => ({
        ...prev,
        currentKey: newCurrentKey,
      }));
    }
  };

  const renderMainTitleStyle = (title, desc) => {
    const key = title.toLowerCase();

    return (
      <h2 data-aos className="body-move__styles__heading" data-key={key}>
        <strong>{title}</strong>
        <span>
          <span>{desc}</span>
        </span>
      </h2>
    );
  };

  const renderHeaderStyle = (item, concept) => {
    const { tag, title: conceptTitle, desc: conceptDesc, img } = concept;

    return (
      <Fragment>
        {item && item.title.toLowerCase() === 'basic' ? (
          <div className="base-move__hide--pc">{renderMainTitleStyle(item.title, item.desc)}</div>
        ) : (
          item && renderMainTitleStyle(item.title, item.desc)
        )}

        <div className="body-move__styles__top" data-key={item?.title.toLowerCase()}>
          <picture className="body-move__styles__top-cover">
            <source media="(min-width: 768px)" srcSet={`${baseImgUrl}${img.big.pc}`} />
            <img alt={img.big.alt} loading="lazy" src={`${baseImgUrl}${img.big.sp}`} />
          </picture>

          <div
            className="body-move__styles__top-content"
            data-key={item ? item.title.toLowerCase() : ''}
          >
            {tag && (
              <h3 data-aos className="body-move__styles__top-content-title">
                <small>{tag}</small>
                <span>
                  {conceptTitle === 'A comfortable fit tailored to your face width' ? (
                    <Fragment>
                      <span>A comfortable fit tailored to</span>
                      <span>your face width</span>
                    </Fragment>
                  ) : (
                    <span>{conceptTitle}</span>
                  )}
                </span>
              </h3>
            )}

            {item && item.title.toLowerCase() === 'basic' && (
              <div className="body-move__styles__heading--basic">
                {renderMainTitleStyle(item.title, item.desc)}
              </div>
            )}

            <p className="body-move__styles__top-content-text">{conceptDesc}</p>

            {img.small && (
              <img
                alt={img.small.alt}
                className="body-move__styles__top-content-img"
                loading="lazy"
                src={`${baseImgUrl}${img.small.img}`}
              />
            )}
          </div>
        </div>
      </Fragment>
    );
  };

  const renderRecommendedStyle = recommended => {
    const { img, alt, badge, titles, listHeader, list } = recommended;

    return (
      <div className="body-move__styles__recommend">
        <div className="base-move__container">
          <div className="body-move__styles__recommend-grid">
            <div className="body-move__styles__recommend-img">
              <img alt={alt} loading="lazy" src={`${baseImgUrl}${img}`} />
              {badge && <span>{badge}</span>}
            </div>
            <div className="body-move__styles__recommend-content">
              <h4 data-aos>
                {titles.map((title, index) => (
                  <span key={`move_recommend-${index + 1}`}>
                    <span>{title}</span>
                  </span>
                ))}
              </h4>
              <h5>{listHeader}</h5>
              <ul>
                {list.map((text, i) => (
                  <li key={`move_recommend-list-${i + 1}`}>{text}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderRecommendedPerfect = recommended => {
    const { title, tag, list } = recommended;

    return (
      <div className="body-move__styles__recommend-perfect">
        <div className="base-move__container">
          <h3 className="body-move__styles__recommend-perfect__title">{title}</h3>

          <ul className="body-move__styles__recommend-perfect__list">
            {list.map(({ text, altStage }, i) => (
              <li
                key={`move__styles__recommend-perfect-${i + 1}`}
                data-aos="fade-up"
                data-aos-delay={i > 0 ? (i + 1) * 100 : i}
              >
                <div className="body-move__styles__recommend-perfect__item-img">
                  <img alt={text} src={`${baseImgUrl}/active/active-slide-${i + 1}.webp`} />
                  <img
                    alt={altStage}
                    src={`${baseImgUrl}/active/active-slide-small-${i + 1}.webp`}
                  />
                </div>
                <span className="body-move__styles__recommend-perfect__item-tag">{tag}</span>
                <p className="body-move__styles__recommend-perfect__item-text">{text}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  };

  const renderProducts = product => {
    const { productNumber, price, colors, limit } = product;
    const productPath = `${baseImgUrl}/products/${productNumber}`;
    const { currentKey, stateProduct, setting, ref } = productMap[productNumber];
    const link = `/sg/en/move-${productNumber.toLowerCase()}-${currentKey.toLowerCase()}-eyeglasses.html`;

    return (
      <div className="body-move__styles__products" data-product-number={productNumber}>
        <div className="body-move__styles__product-bg" data-product-number={productNumber}>
          <div className="body-move__styles__product" data-aos="fade-up">
            <div className="body-move__styles__product-layout">
              <Slider {...setting} ref={ref} className="body-move__styles__product-list">
                {Array.from({ length: limit }, (_, i) => (
                  <li key={`${productNumber}_${currentKey}_0${i + 1}`}>
                    <img
                      alt={productNumber}
                      src={`${productPath}/${productNumber}_${currentKey}_0${i + 1}.webp`}
                    />
                  </li>
                ))}
              </Slider>

              <div className="body-move__styles__product-details">
                <div className="body-move__styles__product-details-content">
                  <div className="body-move__styles__product-details-info">
                    <p className="body-move__styles__product-details-code">
                      <span>{productNumber}</span>
                      <span>{currentKey}</span>
                    </p>
                    <p className="body-move__styles__product-details-price">
                      <small>S$</small>
                      <strong>{price}</strong>
                    </p>
                  </div>

                  <div className="body-move__styles__product-details-colors">
                    {colors.map((color, index) => (
                      <li key={color} data-color-selected={isSelectedColor(currentKey, index)}>
                        <button
                          data-color={color.toLowerCase().replace(' ', '-')}
                          onClick={() => handleSelectedColor(productNumber, index)}
                        />
                      </li>
                    ))}
                  </div>
                </div>
              </div>

              <div className="body-move__styles__product-slide-count">
                {stateProduct.currentIndexProduct + 1} / {limit}
              </div>
            </div>

            <div className="body-move__styles__product-button">
              <a className="base-move__btn base-move__btn--primary" href={link}>
                More Details
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderFeatures = features => {
    const { title, list } = features;

    return (
      <div className="body-move__styles__features">
        <div className="base-move__container">
          <h3 className="body-move__styles__features-title">{title}</h3>

          <ul className="body-move__styles__features-list">
            {list.map((text, i) => (
              <li
                key={text}
                className="body-move__styles__features-item"
                data-aos="fade-up"
                data-aos-delay={i > 0 ? (i + 1) * 100 : i}
              >
                <img
                  alt={text}
                  className="body-move__styles__features-icon"
                  loading="lazy"
                  src={`${baseImgUrl}/basic/feature-${i + 1}.webp`}
                />
                <div className="body-move__styles__features-details">
                  <small>#0{i + 1}</small>
                  <p>{text}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  };

  return (
    <Fragment>
      <section className="body-move__styles">
        <div id={STYLES.active.title.toLowerCase()}>
          {renderHeaderStyle(STYLES.active, STYLES.active.concept['4-level'])}
          {renderRecommendedStyle(STYLES.active.concept['4-level'].recommended)}
          {renderRecommendedPerfect(STYLES.active.concept['4-level'].recommendedPerfect)}

          {renderProducts(PRODUCTS['MV2003N-5S'])}
          {renderProducts(PRODUCTS['MV2004N-5S'])}

          {renderHeaderStyle(null, STYLES.active.concept['2-step'])}
          {renderRecommendedStyle(STYLES.active.concept['2-step'].recommended)}

          {renderProducts(PRODUCTS['MV2005N-5S'])}
          {renderProducts(PRODUCTS['MV2006N-5S'])}
        </div>

        <div id={STYLES.basic.title.toLowerCase()}>
          {renderHeaderStyle(STYLES.basic, STYLES.basic.concept)}

          {renderFeatures(STYLES.basic.features)}

          {renderProducts(PRODUCTS['MV2001N-5S'])}
          {renderProducts(PRODUCTS['MV2002N-5S'])}
        </div>
      </section>
    </Fragment>
  );
};
